import { lazy, Suspense } from 'react';

import { observer } from 'mobx-react';

import { useStores } from '../../../stores/useStores';

// Lazy so the dialog (and dayjs/Trans/intercom it pulls in) stays out of the main bundle.
const UserCoolDownDialog = lazy(() => import('./UserCooldownDialog').then((m) => ({ default: m.UserCoolDownDialog })));

// Renders the blocking cool down dialog on top of the lobby, outside the app portal — the portal
// holds a single component at a time, so an auth wizard would otherwise replace or close it.
export const UserCoolDownGate = observer(() => {
  const { authStore, userStore } = useStores();

  // Wait for the lobby to be ready, otherwise the dialog sits on the boot loader's black screen.
  const lobbyReady = authStore.isAuthenticationFlowDone && !userStore.loading;

  if (!authStore.userCoolDown || !lobbyReady) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <UserCoolDownDialog />
    </Suspense>
  );
});
